
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("i6Hw8", function(module, exports) {

$parcel$export(module.exports, "SmartsSummaryErrorComponent", () => $b23bda466b375951$export$2e01ba79c8bb8074);
/* SmartsSummaryErrorComponent.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $fT2ta = parcelRequire("fT2ta");

var $inPa6 = parcelRequire("inPa6");

var $gdv5Z = parcelRequire("gdv5Z");
var $eyWa4 = parcelRequire("eyWa4");
var $iXCQx = parcelRequire("iXCQx");

var $dIouf = parcelRequire("dIouf");

var $dL3KX = parcelRequire("dL3KX");

var $5N3K0 = parcelRequire("5N3K0");

var $53ZHq = parcelRequire("53ZHq");

var $bbNJt = parcelRequire("bbNJt");
const $b23bda466b375951$var$i18nShared = (0, $2nPZH.defineMessages)({
    generalError: {
        id: "quick-summary.error.general-error",
        defaultMessage: "Atlassian Intelligence can\u2019t provide a response right now. Read more <a>in our support documentation</a>."
    },
    notEnoughContent: {
        id: "quick-summary.error.not-enough-content",
        defaultMessage: "There isn\u2019t enough content here to summarize. Try again when more content has been added."
    },
    rateLimit: {
        id: "quick-summary.error.rate-limit",
        defaultMessage: "Excessive use has been detected with Atlassian Intelligence. Try again later. Read more <a>in our support documentation</a>."
    }
});
const $b23bda466b375951$var$i18nForPage = (0, $2nPZH.defineMessages)({
    tooMuchContent: {
        id: "quick-summary.error.too-much-content",
        defaultMessage: "Atlassian Intelligence can\u2019t generate a summary for you right now, as there is too much content to summarize."
    },
    aupViolation: {
        id: "quick-summary.error.aup-violation",
        defaultMessage: "Your content might not comply with our Acceptable Use Policy. Please review and refer to our <a>Acceptable Use Policy</a> if needed."
    }
});
const $b23bda466b375951$var$i18nForComments = (0, $2nPZH.defineMessages)({
    tooMuchContent: {
        id: "quick-summary.error.too-much-content-comments",
        defaultMessage: "There\u2019s too much here for Atlassian Intelligence to summarize. Try again with content that has fewer comments."
    },
    aupViolation: {
        id: "quick-summary.error.aup-violation-comments",
        defaultMessage: "We can\u2019t provide a summary of comments at this time, as some comments may not comply with Atlassian\u2019s <a>Acceptable Use Policy</a>."
    }
});
const $b23bda466b375951$var$i18nForPageCatchup = (0, $2nPZH.defineMessages)({
    tooMuchContent: {
        id: "quick-summary.error.too-much-content-page-catchup",
        defaultMessage: "There are too many changes for Atlassian Intelligence (AI) to summarize. Try again with content that has fewer changes."
    },
    aupViolation: {
        id: "quick-summary.error.aup-violation-page-catchup",
        defaultMessage: "Atlassian Intelligence (AI) can\u2019t provide a summary of changes to this content, as some changes may not comply with our <a>Acceptable Use Policy</a>."
    }
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b23bda466b375951$var$QuickSummaryErrorBody = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = (0, $bbNJt.SummaryPopupScrollableBody), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_11c82smr _syaz131l",
            __cmplp.className
        ])
    });
});
const $b23bda466b375951$export$2e01ba79c8bb8074 = ({ analyticsProperties: analyticsProperties, errorFromApolloOrStream: errorFromApolloOrStream, contentId: contentId, experienceName: experienceName, summarizedByInHeader: summarizedByInHeader = false, shouldShowBetaFlag: shouldShowBetaFlag = false })=>{
    const intl = (0, $dBxQj.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { isExpectedError: isExpectedError, stopExperienceTracking: stopExperienceTracking, errorType: errorType, error: error } = (0, $dL3KX.useSummaryErrorHelper)(experienceName, errorFromApolloOrStream);
    const errorScreenEventName = analyticsProperties.source === 'quickSummary' ? 'quickSummaryDialogError' : `${analyticsProperties.source}Error`;
    const sourceBasedErrorMessagesSet = ()=>{
        switch(analyticsProperties.source){
            case 'commentsSummary':
                return $b23bda466b375951$var$i18nForComments;
            case 'pageCatchup':
                return $b23bda466b375951$var$i18nForPageCatchup;
            default:
                return $b23bda466b375951$var$i18nForPage;
        }
    };
    (0, $gwFzn.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: errorScreenEventName,
                attributes: {
                    contentId: contentId,
                    errorType: errorType || 'generalError',
                    ...analyticsProperties.additionalAnalyticsAttributes
                }
            }
        }).fire();
    }, [
        contentId,
        createAnalyticsEvent,
        errorScreenEventName,
        errorType,
        analyticsProperties
    ]);
    const onDocsLinkClicked = (linkName)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: analyticsProperties.source,
                action: 'clicked',
                actionSubject: 'link',
                actionSubjectId: `atlassianIntelligence${linkName}DocsLink`,
                attributes: {
                    contentId: contentId,
                    ...analyticsProperties.additionalAnalyticsAttributes
                }
            }
        }).fire();
    };
    let errorMessage;
    switch(errorType){
        case (0, $dL3KX.HandledErrorType).TooMuchContent:
            errorMessage = intl.formatMessage(sourceBasedErrorMessagesSet().tooMuchContent);
            break;
        case (0, $dL3KX.HandledErrorType).NotEnoughContent:
            errorMessage = intl.formatMessage($b23bda466b375951$var$i18nShared.notEnoughContent);
            break;
        case (0, $dL3KX.HandledErrorType).AUPViolation:
            errorMessage = intl.formatMessage(sourceBasedErrorMessagesSet().aupViolation, {
                a: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("a", {
                        href: (0, $53ZHq.ACCEPTABLE_USE_POLICY_URL),
                        target: "_blank",
                        onClick: ()=>onDocsLinkClicked('AupViolation')
                    }, chunks)
            });
            break;
        case (0, $dL3KX.HandledErrorType).RateLimit:
            errorMessage = intl.formatMessage($b23bda466b375951$var$i18nShared.rateLimit, {
                a: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("a", {
                        href: (0, $53ZHq.USAGE_LIMITS_DOCS_URL),
                        target: "_blank",
                        onClick: ()=>onDocsLinkClicked('RateLimit')
                    }, chunks)
            });
            break;
        default:
            errorMessage = intl.formatMessage($b23bda466b375951$var$i18nShared.generalError, {
                a: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("a", {
                        href: (0, $53ZHq.TROUBLE_SHOOTING_DOCS_URL),
                        target: "_blank",
                        onClick: ()=>onDocsLinkClicked('Troubleshooting')
                    }, chunks)
            });
    }
    stopExperienceTracking();
    const summarizedByComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5N3K0.SmartsSummarizedByComponent), {
        analyticsProperties: analyticsProperties,
        contentId: contentId,
        error: true,
        shouldShowBetaFlag: shouldShowBetaFlag
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $fT2ta.default), {
        entranceDirection: "top"
    }, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gdv5Z.default), {
            ...props,
            padding: "space.250"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eyWa4.default), {
            space: "space.250",
            testId: "smmarts-summary-error"
        }, summarizedByInHeader && summarizedByComponent, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($b23bda466b375951$var$QuickSummaryErrorBody, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $iXCQx.default), {
            as: "p"
        }, errorMessage)), !summarizedByInHeader && summarizedByComponent), !isExpectedError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorDisplay), {
            error: error
        })));
};

});
parcelRegister("5N3K0", function(module, exports) {

$parcel$export(module.exports, "SmartsSummarizedByComponent", () => $5c015c85edc9f454$export$b6b9d22877e2756);
/* SmartsSummarizedByComponent.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");
var $dBxQj = parcelRequire("dBxQj");

var $1s5hv = parcelRequire("1s5hv");
var $u9agA = parcelRequire("u9agA");
var $eyWa4 = parcelRequire("eyWa4");
var $iXCQx = parcelRequire("iXCQx");

var $3gadb = parcelRequire("3gadb");

var $eEA8O = parcelRequire("eEA8O");

var $inPa6 = parcelRequire("inPa6");

var $aIk0I = parcelRequire("aIk0I");

var $6ffMd = parcelRequire("6ffMd");

var $81IZv = parcelRequire("81IZv");

var $d3K8Q = parcelRequire("d3K8Q");
const $5c015c85edc9f454$var$i18n = (0, $2nPZH.defineMessages)({
    footerTitle: {
        id: "quick-summary.quick-summary-footer.footer-title",
        defaultMessage: "Summarized by Atlassian Intelligence"
    },
    whatElseCanAIDoLink: {
        id: "quick-summary.quick-summary-footer.what-can-ai-do-link",
        defaultMessage: "What else can Atlassian Intelligence help me with?"
    },
    footerTitleError: {
        id: "quick-summary.quick-summary-footer.footer-title-error",
        defaultMessage: "Atlassian Intelligence"
    },
    qualityDescriptor: {
        id: "quick-summary.quick-summary-footer.quality-descriptor",
        defaultMessage: "The quality, accuracy, and reliability of information generated by Atlassian Intelligence may vary."
    },
    learnMoreLink: {
        id: "quick-summary.quick-summary-footer.learn-more-link",
        defaultMessage: "Learn more"
    },
    logoAltText: {
        id: "quick-summary.quick-summary-footer.logo-alt-text",
        defaultMessage: "Atlassian Intelligence Logo"
    },
    moreInfo: {
        id: "quick-summary.quick-summary-footer.more-info",
        defaultMessage: "more info"
    },
    betaLozenge: {
        id: "quick-summary.summary-footer.beta-lozenge",
        defaultMessage: "Beta"
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5c015c85edc9f454$var$Title = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_11c81vhk _syaz1gjq",
            __cmplp.className
        ])
    });
});
const $5c015c85edc9f454$var$LearnMoreWrapper = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_4bfu18uv _1hms8stv _ajmmnqa1 _syaz15cr _k48pi7a9",
            __cmplp.className
        ])
    });
});
const $5c015c85edc9f454$var$QuestionLink = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_4bfu18uv _1hms8stv _ajmmnqa1 _11c8dcr7 _syaz131l",
            __cmplp.className
        ])
    });
});
const $5c015c85edc9f454$export$b6b9d22877e2756 = ({ analyticsProperties: analyticsProperties, contentId: contentId, summaryId: summaryId, error: error, shouldShowLearnMoreLink: shouldShowLearnMoreLink = true, shouldShowBetaFlag: shouldShowBetaFlag = false })=>{
    const intl = (0, $dBxQj.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const onLearnMoreClicked = (e)=>{
        e.stopPropagation();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: analyticsProperties.source,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: `${analyticsProperties.source}LearnWhyLink`,
                attributes: {
                    contentId: contentId
                }
            }
        }).fire();
    };
    const onAIDocsLinkClicked = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: analyticsProperties.source,
                action: 'clicked',
                actionSubject: 'link',
                actionSubjectId: 'atlassianIntelligenceProductInfoLink',
                attributes: {
                    contentId: contentId,
                    summaryId: summaryId,
                    ...analyticsProperties.additionalAnalyticsAttributes
                }
            }
        }).fire();
    };
    const moreInfoContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $iXCQx.default), {
        as: "p",
        color: "color.text.inverse"
    }, intl.formatMessage($5c015c85edc9f454$var$i18n.qualityDescriptor), "\xa0", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eEA8O.default), {
        appearance: "subtle-link",
        spacing: "none",
        onClick: onLearnMoreClicked,
        href: (0, $6ffMd.ATLASSIAN_INTELLIGENCE_LEARN_MORE_LINK),
        target: "_blank"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($5c015c85edc9f454$var$LearnMoreWrapper, null, intl.formatMessage($5c015c85edc9f454$var$i18n.learnMoreLink))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $u9agA.default), {
        space: "space.050",
        alignBlock: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $81IZv.AtlassianIntelligenceLogo), {
        alt: intl.formatMessage($5c015c85edc9f454$var$i18n.logoAltText)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eyWa4.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $u9agA.default), {
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($5c015c85edc9f454$var$Title, null, error ? intl.formatMessage($5c015c85edc9f454$var$i18n.footerTitleError) : intl.formatMessage($5c015c85edc9f454$var$i18n.footerTitle)), shouldShowBetaFlag && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $aIk0I.default), {
        appearance: "new"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $5c015c85edc9f454$var$i18n.betaLozenge)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3gadb.default), {
        content: moreInfoContent,
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1s5hv.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $d3K8Q.InfoIcon), {
        label: intl.formatMessage($5c015c85edc9f454$var$i18n.moreInfo)
    })))), !error && shouldShowLearnMoreLink && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eEA8O.default), {
        appearance: "subtle-link",
        spacing: "none",
        onClick: onAIDocsLinkClicked,
        href: (0, $6ffMd.ATLASSIAN_INTELLIGENCE_LEARN_MORE_LINK),
        target: "_blank"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($5c015c85edc9f454$var$QuestionLink, null, intl.formatMessage($5c015c85edc9f454$var$i18n.whatElseCanAIDoLink)))));
};

});
parcelRegister("6ffMd", function(module, exports) {

$parcel$export(module.exports, "ATLASSIAN_INTELLIGENCE_LEARN_MORE_LINK", () => $70389f130e8ebd5a$export$d6aa5f0c6d74941c);
const $70389f130e8ebd5a$export$d6aa5f0c6d74941c = 'https://support.atlassian.com/organization-administration/docs/understand-atlassian-intelligence-features-in-products';

});

parcelRegister("81IZv", function(module, exports) {

$parcel$export(module.exports, "AtlassianIntelligenceLogo", () => $3fac544ce95b5bf0$export$b58d43d92d088553);

var $gwFzn = parcelRequire("gwFzn");

var $3Mg7y = parcelRequire("3Mg7y");
const $3fac544ce95b5bf0$export$b58d43d92d088553 = ({ alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3Mg7y))), {
        color: "currentColor",
        label: alt
    });

});

parcelRegister("d3K8Q", function(module, exports) {

$parcel$export(module.exports, "InfoIcon", () => $ca275cf613854693$export$2957fc44b3d2481);

var $gwFzn = parcelRequire("gwFzn");

var $4vzBZ = parcelRequire("4vzBZ");
const $ca275cf613854693$export$2957fc44b3d2481 = ({ label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4vzBZ))), {
        testId: "info-icon",
        label: label,
        color: "var(--ds-icon-subtle, #626F86)"
    });

});




//# sourceMappingURL=SmartsSummaryErrorComponent.6ced65e3.js.map
